import { useState } from 'react';
import { i18n } from '@lingui/core';
import { t, Trans } from '@lingui/macro';
import _ from 'lodash';
import { MenuItem } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import FormSection from '../../form/FormSection';
import {
    AGENT_BEACON_PACKETS_ENABLED_OPTION,
    AGENT_BEACON_PACKETS_GLOBAL_OPTION,
    AGENT_BEACON_PACKETS_GLOBAL_OPTION_TEXT,
    AGENT_BEACON_PACKETS_GLOBAL_WIRED_OPTION_TEXT,
    AGENT_BEACON_PACKETS_GLOBAL_WIRELESS_OPTION_TEXT,
    AGENT_BEACON_PACKETS_INTERFACES_GLOBAL_OPTION,
    AGENT_BEACON_PACKETS_OPTIONS,
    AGENT_BEACON_PACKETS_SELECTION_FIELD,
    AGENT_BEACON_PACKETS_WIRED_SELECTION_FIELD,
    AGENT_BEACON_PACKETS_WIRELESS_SELECTION_FIELD,
    AGENT_WIFI_SELECTION_FIELD,
    AGENT_WIFI_SINGLE_SSID_OPTION,
    GLOBAL_AGENT_SETTINGS_FIELD,
} from './AgentConstants';
import NgpSelect from '../../form/NgpSelect';
import { buildBeaconInterfaceOptions } from '../agent-settings/AgentSettingsHelper';
import { BEACON_PACKETS_FIELD } from '../agent-settings/AgentSettingsConstants';

const beaconPacketsSelectionHelpTip = i18n._(t`ASI Monitoring for Service Tests selection`);
const beaconPacketsInterfaceSelectionHelpTip = i18n._(t`The number of interfaces used for Smart Edge Monitoring`);

const beaconInterfaceOptions = buildBeaconInterfaceOptions();

function areBeaconsEnabled(selectionValue, beaconsGloballyEnabled) {
    if (selectionValue === AGENT_BEACON_PACKETS_GLOBAL_OPTION && beaconsGloballyEnabled) {
        return true;
    }

    if (selectionValue === AGENT_BEACON_PACKETS_ENABLED_OPTION) {
        return true;
    }

    return false;
}

export function AgentDetailBeacons({ formData, classes, isHardware3kAgent }) {
    const showInterfacesSection = isHardware3kAgent.current;
    const { watch } = useFormContext();
    const wifiSelection = watch(AGENT_WIFI_SELECTION_FIELD);
    const globalBeaconSettings = formData[GLOBAL_AGENT_SETTINGS_FIELD];
    const beaconsGloballyEnabled = _.get(globalBeaconSettings, BEACON_PACKETS_FIELD, false);
    const [beaconsEnabled, setBeaconsEnabled] = useState(
        areBeaconsEnabled(_.get(formData, AGENT_BEACON_PACKETS_SELECTION_FIELD), beaconsGloballyEnabled)
    );

    const handleBeaconSelectionChange = (e) => {
        setBeaconsEnabled(areBeaconsEnabled(e.target.value, beaconsGloballyEnabled));
    };

    return (
        <FormSection title={<Trans>Smart Edge Monitoring</Trans>}>
            <NgpSelect
                fieldName={AGENT_BEACON_PACKETS_SELECTION_FIELD}
                label={<Trans>Smart Edge Monitoring</Trans>}
                required
                className={classes.beaconSelect}
                helpTipText={beaconPacketsSelectionHelpTip}
                onChangeFunc={handleBeaconSelectionChange}
            >
                <MenuItem value={AGENT_BEACON_PACKETS_GLOBAL_OPTION}>
                    {_.get(formData, AGENT_BEACON_PACKETS_GLOBAL_OPTION_TEXT)}
                </MenuItem>
                {_.map(AGENT_BEACON_PACKETS_OPTIONS, (value, key) => (
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                ))}
            </NgpSelect>

            {beaconsEnabled && (
                <>
                    {showInterfacesSection && (
                        <>
                            <NgpSelect
                                fieldName={AGENT_BEACON_PACKETS_WIRED_SELECTION_FIELD}
                                label={<Trans>Virtual Ethernet Interfaces</Trans>}
                                className={classes.beaconSelect}
                                helpTipText={beaconPacketsInterfaceSelectionHelpTip}
                            >
                                <MenuItem value={AGENT_BEACON_PACKETS_INTERFACES_GLOBAL_OPTION}>
                                    {_.get(formData, AGENT_BEACON_PACKETS_GLOBAL_WIRED_OPTION_TEXT)}
                                </MenuItem>
                                {_.map(beaconInterfaceOptions, (value, key) => (
                                    <MenuItem key={key} value={key}>
                                        {value}
                                    </MenuItem>
                                ))}
                            </NgpSelect>

                            {wifiSelection === AGENT_WIFI_SINGLE_SSID_OPTION && (
                                <NgpSelect
                                    fieldName={AGENT_BEACON_PACKETS_WIRELESS_SELECTION_FIELD}
                                    label={<Trans>Virtual Wi-Fi Interfaces</Trans>}
                                    className={classes.beaconSelect}
                                    helpTipText={beaconPacketsInterfaceSelectionHelpTip}
                                >
                                    <MenuItem value={AGENT_BEACON_PACKETS_INTERFACES_GLOBAL_OPTION}>
                                        {_.get(formData, AGENT_BEACON_PACKETS_GLOBAL_WIRELESS_OPTION_TEXT)}
                                    </MenuItem>
                                    {_.map(beaconInterfaceOptions, (value, key) => (
                                        <MenuItem key={key} value={key}>
                                            {value}
                                        </MenuItem>
                                    ))}
                                </NgpSelect>
                            )}
                        </>
                    )}
                </>
            )}
        </FormSection>
    );
}
